import request from '@/router/axios'

export function getPage(data) {
    return request({
        url: '/chain/companycard/getCCardAccountInfoPage',
        method: 'post',
        data
    })
}
export function getCCardAccountCount(data) {
  return request({
      url: '/chain/companycard/getCCardAccountCount',
      method: 'post',
      data
  })
}
